export default __webpack_public_path__ + "static/mg-careers-logo-dark-16eba9bf67167df4441e9a8063fdc801.svg";